import type { ObservationImage } from "@/entities/observation";

export const getNumberOfMasonryColumns = (images?: ObservationImage[]) => {
  const numberOfItems = images?.length ?? 0;

  if (numberOfItems <= 3) return 1;

  if (numberOfItems <= 6) return 2;

  return 3;
};
